<template>
    <BreadCrumb PageTitle="Liste des casiers" />
    <ListeCasier/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeCasier from "../../components/Casier/ListeCasier.vue";

    export default defineComponent({
      name: "ListeCasierPage",
      components: {
        BreadCrumb,
        ListeCasier,
      },
    });
  </script>